import { withFields } from 'app-webtech-core/beacon/withFields';
import {
  APP_LAUNCH,
  APP_LAUNCH_TRACK,
  APP_LOADED,
  UNDEFINED_ERROR,
  POLICY_ACCEPTED,
  POLICY_VIEWED,
  POLICY_VIEWED_ACCEPTED,
  BOOTSTRAP_REQUEST,
  BOOTSTRAP_LOADED,
  BOOTSTRAP_RESTART_REQUEST,
  LINK_CLICK,
} from '../actions/types';
import { appLaunchBeacon } from './appLaunch';
import { appLoadedBeacon } from './appLoaded';
import { appLaunchTrackBeacon } from './appLaunchTrack';
import { undefinedErrorBeacon } from './undefinedError';
import { policyAcceptedBeacon } from './policyAccepted';
import { policyViewedBeacon } from './policyViewed';
import { policyViewedAcceptedBeacon } from './policyViewedAccepted';
import { bootstrapRequestBeacon } from './bootstrapRequest';
import { bootstrapLoadedBeacon } from './bootstrapLoaded';
import { bootstrapRestartRequestBeacon } from './bootstrapRestartRequest';
import { linkClickBeacon } from './linkClick';

export const applicationEventDefinitionsMap = {
  [APP_LAUNCH]: withFields(appLaunchBeacon),
  [APP_LAUNCH_TRACK]: withFields(appLaunchTrackBeacon),
  [APP_LOADED]: withFields(appLoadedBeacon),
  [UNDEFINED_ERROR]: withFields(undefinedErrorBeacon),
  [POLICY_ACCEPTED]: withFields(policyAcceptedBeacon),
  [POLICY_VIEWED]: withFields(policyViewedBeacon),
  [POLICY_VIEWED_ACCEPTED]: withFields(policyViewedAcceptedBeacon),
  [BOOTSTRAP_REQUEST]: withFields(bootstrapRequestBeacon),
  [BOOTSTRAP_LOADED]: withFields(bootstrapLoadedBeacon),
  [BOOTSTRAP_RESTART_REQUEST]: withFields(bootstrapRestartRequestBeacon),
  [LINK_CLICK]: withFields(linkClickBeacon),
};
